import React from 'react';
import MetaTag from '@/components/ui/MetaTag';
import { ArticleList, Breadcrumb, Eyebrow, JournalShell, Section } from './components';
import type { JournalArticle } from './const';

export const JournalBrandNewsLayout = ({ articles }: { articles: JournalArticle[] }) => (
  <JournalShell activeKey="tin-an-thu">
    <MetaTag title="Tin An Thư: sự kiện & hoạt động mới nhất" description="Theo dõi sự kiện, hoạt động thương hiệu và những thông tin mới nhất từ An Thư The Diamond Store." />
    <Breadcrumb items={[{ label: 'Trang chủ', href: '/' }, { label: 'Tin tức', href: '/tin-tuc/' }, { label: 'Tin An Thư' }]} />
    <Section className="!tw-pt-6 md:!tw-pt-8">
      <Eyebrow>GÓC AN THƯ</Eyebrow>
      <h1 className="tw-font-jr tw-mt-4 tw-mb-4 tw-text-4xl md:tw-text-5xl tw-font-normal">Tin An Thư</h1>
      <p className="tw-max-w-[720px] tw-mb-10 tw-text-lg tw-text-jr-mute">Sự kiện, hoạt động thương hiệu và những câu chuyện mới nhất từ An Thư.</p>
      {articles.length ? <ArticleList items={articles} /> : <p className="tw-text-jr-mute">Tin tức và sự kiện của An Thư đang được cập nhật.</p>}
    </Section>
  </JournalShell>
);
